import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config/api";
import { useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaSearch,
  FaSort,
  FaFilter,
  FaCheckCircle,
  FaTimesCircle
} from "react-icons/fa";

function ProductDetails() {

  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [searchName, setSearchName] = useState("");
  const [searchSchool, setSearchSchool] = useState("");

  const [schools, setSchools] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState("");

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc"
  });

  const API_URL = `${API_BASE_URL}/uniform`;

  useEffect(() => {
    fetchProducts();
    fetchSchools();
  }, []);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_URL}/all`);
      setProducts(res.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchSchools = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/schools`);
      setSchools(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const toggleStatus = async (id, currentStatus) => {
    try {

      const newStatus = !currentStatus;

      await axios.put(
        `${API_BASE_URL}/uniform/availability/${id}`,
        { isAvailable: newStatus }
      );

      setProducts((prev) =>
        prev.map((p) =>
          p._id === id
            ? { ...p, isAvailable: newStatus }
            : p
        )
      );

    } catch (err) {
      alert("Error updating status");
    }
  };

  const requestSort = (key) => {

    let direction = "asc";

    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    setSortConfig({ key, direction });

  };

  const filteredProducts = products
    .filter((item) => {

      const nameMatch = item.description
        ?.toLowerCase()
        .includes(searchName.toLowerCase());

      const schoolMatch = (item.schoolId?.name || "")
        .toLowerCase()
        .includes(searchSchool.toLowerCase());

      const dropdownMatch =
        selectedSchool === "" ||
        item.schoolId?.name === selectedSchool;

      return nameMatch && schoolMatch && dropdownMatch;

    })
    .sort((a, b) => {

      if (!sortConfig.key) return 0;

      let valA =
        sortConfig.key === "schoolId"
          ? a.schoolId?.name
          : a[sortConfig.key];

      let valB =
        sortConfig.key === "schoolId"
          ? b.schoolId?.name
          : b[sortConfig.key];

      if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;

      return 0;

    });

  if (loading) {
    return (
      <div className="p-5 text-center text-success fw-bold">
        Loading Products...
      </div>
    );
  }

  return (

    <div className="p-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>

      {/* BACK BUTTON */}

      <button
        className="btn btn-md d-flex align-items-center gap-2 fw-bold text-muted border-0 bg-transparent"
        onClick={() => navigate(-1)}
      >
        <FaArrowLeft /> Back
      </button>

      {/* HEADER */}

      <div className="d-flex justify-content-between align-items-center mb-4 p-3 bg-white shadow-sm rounded-4 border-start border-success border-5">
        <h3 className="fw-bold text-dark mb-0">
          Uniform Management
        </h3>
      </div>

      {/* SEARCH FILTER */}

      <div className="d-flex justify-content-end align-items-center mb-4 gap-3">

        <div className="position-relative" style={{ width: "250px" }}>
          <FaSearch className="position-absolute top-50 translate-middle-y ms-3 text-muted" />
          <input
            type="text"
            className="form-control ps-5 border-0 shadow-sm"
            placeholder="Search Name..."
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
            style={{ borderRadius: "10px", height: "38px" }}
          />
        </div>

        <div className="position-relative" style={{ width: "250px" }}>
          <FaSearch className="position-absolute top-50 translate-middle-y ms-3 text-muted" />
          <input
            type="text"
            className="form-control ps-5 border-0 shadow-sm"
            placeholder="Search School..."
            value={searchSchool}
            onChange={(e) => setSearchSchool(e.target.value)}
            style={{ borderRadius: "10px", height: "38px" }}
          />
        </div>

        <div style={{ width: "220px", position: "relative" }}>
          <FaFilter className="position-absolute top-50 translate-middle-y ms-3 text-muted" />
          <select
            className="form-select ps-5 border-0 shadow-sm"
            value={selectedSchool}
            onChange={(e) => setSelectedSchool(e.target.value)}
            style={{ borderRadius: "10px", height: "38px" }}
          >
            <option value="">All Products</option>

            {schools.map((s) => (
              <option key={s._id} value={s.name}>
                {s.name}
              </option>
            ))}

          </select>
        </div>

      </div>

      {/* TABLE */}

      <div className="card border-0 shadow-sm rounded-3 overflow-hidden">

        <div className="table-responsive">

          <table className="table table-hover align-middle mb-0">

            <thead style={{ backgroundColor: "#70b39d" }}>

              <tr>

                <th className="ps-4 py-3"
                  onClick={() => requestSort("description")}
                  style={{ cursor: "pointer" }}>
                  Name <FaSort size={10} />
                </th>

                <th
                  onClick={() => requestSort("schoolId")}
                  style={{ cursor: "pointer" }}>
                  School <FaSort size={10} />
                </th>

                <th>Category</th>

                <th
                  onClick={() => requestSort("price")}
                  style={{ cursor: "pointer" }}>
                  Price <FaSort size={10} />
                </th>

                <th className="text-center">
                  Status
                </th>

              </tr>

            </thead>

            <tbody>

              {filteredProducts.map((item) => (

                <tr key={item._id}>

                  <td className="ps-4">
                    <div className="d-flex align-items-center gap-3">

                      <img
                        src={`${API_BASE_URL}/uploads/${item.image}`}
                        alt="product"
                        style={{
                          width: "40px",
                          height: "40px",
                          objectFit: "cover",
                          borderRadius: "6px"
                        }}
                      />

                      <span className="text-secondary">
                        {item.description?.substring(0, 25)}...
                      </span>

                    </div>
                  </td>

                  <td className="text-muted">
                    {item.schoolId?.name || "N/A"}
                  </td>

                  <td className="text-muted small">
                    {item.gender} | {item.season}
                  </td>

                  <td className="fw-bold">
                    ₹{item.price}
                  </td>

                  {/* STATUS COLUMN */}

                  <td className="text-center">

                    <div className="d-flex flex-column align-items-center gap-1">

                      <span
                        className="fw-bold"
                        style={{
                          fontSize: "11px",
                          color: item.isAvailable ? "#34a87b" : "#dc3545"
                        }}
                      >

                        {item.isAvailable ? (
                          <>
                            <FaCheckCircle className="me-1" />
                            ACTIVE
                          </>
                        ) : (
                          <>
                            <FaTimesCircle className="me-1" />
                            INACTIVE
                          </>
                        )}

                      </span>

                      <div className="form-check form-switch">

                        <input
                          className="form-check-input pointer"
                          type="checkbox"
                          checked={item.isAvailable}
                          onChange={() =>
                            toggleStatus(item._id, item.isAvailable)
                          }
                        />

                      </div>

                    </div>

                  </td>
                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>

      <style>{`

      .pointer{
        cursor:pointer;
      }

      .form-check-input:checked{
        background-color:#34a87b;
        border-color:#34a87b;
      }

      `}</style>

    </div>

  );
}

export default ProductDetails;